import React, {Component} from 'react';

class DownloadAndSafety extends Component{

  constructor(props){
    super(props)
    this.icon = this.props.affiliate === 'kotv'
    ? `https://ftpcontent.worldnow.com/kotv/custom/wxtakeover/6weathericon_lg.png`
     : `https://ftpcontent.worldnow.com/kotv/custom/wxtakeover/9weathericon_lg.png`
    this.station = this.props.affiliate === 'kotv'? 'News on 6' : 'News 9'
    this.textMessage =  this.props.affiliate === 'kotv'? 'Travis' : 'David'
    this.stationCall = this.affiliate == 'kotv' ? 'newson6' : 'news9';
    this.social = {
      fb: `https://www.facebook.com/sharer/sharer.php?u=http%3A//www.${this.stationCall}.com/`,
      twitter: `https://twitter.com/home?status=Watch%20Live%20-%20Severe%20Weather%20Coverage%20on%20http%3A//www.${this.stationCall}.com%20%23okwx`,
      email: `mailto:?&subject=Watch Live - Severe Weather Coverage&body=Watch%20Live%20-%20Severe%20Weather%20Coverage%20on%20http%3A//www.${this.stationCall}.com`
    }
  }
  render(){
    return(
      <div className='row hidden-xs download-and-safety '>
        <div className='download col-xs-12'>
          <img className='img-responsive logo' src={this.icon} />

          <h6>Download the App </h6>
          <p>Text {this.textMessage} to 79640</p>
        </div>
        <div className='safety col-xs-12'>
          <h6>Share and Help Others Stay Safe</h6>
          <div className="row">
            <div className='col-xs-4'>
              <a href={this.social.fb} className='social-icons centered'>
                <i className='fa fa-facebook'  />
              </a>
            </div>
            <div className='col-xs-4'>
              <a href={this.social.twitter} className='social-icons centered'>
                <i className='fa fa-twitter'  />
              </a>
            </div>
            <div className='col-xs-4'>
              <a href={this.social.email} className='social-icons centered'>
                <i className='fa fa-envelope'  />

              </a>
            </div>
          </div>

        </div>
      </div>
    )
  }
}

export default DownloadAndSafety



// WEBPACK FOOTER //
// ./app/components/custom/ssr/WeatherTakeover/DownloadAndSafety.js